import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import Datatable from "../components/datatable/Datatable";
import PeopleIcon from "@mui/icons-material/People";

function Clientes() {
  const people = PeopleIcon;
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar
          title="Clientes"
          icon={people}
          // tutorialData={{
          //   type: "video",
          //   content: "https://vimeo.com/1141421461",
          //   title: "Página Clientes",
          // }}
        />
        <Datatable />
      </div>
    </div>
  );
}

export default Clientes;
